module.exports = __webpack_public_path__ + "assets/svg/UI/map-pin-clock-out-e9f5a1.svg";